/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { FC } from "react";
import { useRoutes } from "react-router-dom";

import AppShell from "~/components/AppShell";
import pageRoutes from "~/setup/routes.generated";

const AppRoutes: FC = () => {
  return useRoutes([
    {
      path: "/",
      element: <AppShell />,
      children: pageRoutes,
    },
  ]);
};

export default AppRoutes;
